module.exports = __webpack_public_path__ + "static/media/block-4-rocklea.78fde0f1.png";